// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BLOGS_ADD_NEW_POST_PLACEHOLDER = "Za\u010dni p\u00edsa\u0165 pr\u00edspevok...";
export const FORUM_COMMENT_FORM_EMPTY_MESSAGE_CANNOT_BE_SENT = "Pr\u00e1zdnu spr\u00e1vu nem\u00f4\u017ee\u0161 odosla\u0165";
export const HIDE_REPLIES = "Nezobrazuj koment\u00e1re";
export const SEND_COMMENT_FORUM = "Odo\u0161li";
export const SHOW_IN_CONTESTS = "Zobrazuj v \"S\u00fa\u0165a\u017ee\"";
export const VISIBILITY_CHECKBOX_LABEL = "Zverejni aj pre neregistrovan\u00fdch";
